import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import sessionlessLoadingAnimation from "assets/sessionlessLoading.json";

function SessionlessAnimation() {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: container.current as Element,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: sessionlessLoadingAnimation,
    });
  }, []);

  return (
    <div
      className="container"
      style={{ width: 300, height: 300 }}
      ref={container}
    ></div>
  );
}
export default SessionlessAnimation;
